module.exports = __webpack_public_path__ + "img/Smart_mobility_INdia.8685301c.png";